import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    standalone: false
})
export class ContainerComponent implements OnInit {
  @Input() contentAlign: string;
  ngOnInit(): void {

    switch (this.contentAlign) {
      case 'start':
        this.contentAlign = 'justify-start'
        break;
      default:
        this.contentAlign = 'justify-center'
        break;
    }
  }
}
